import React from 'react'
import { colors } from '../../../../styles/vars/colors.style'

const ExpeditionRoute2 = ({
  width = 317,
  height = 316,
  stroke = colors.dark,
  mask = colors.light,
  opacity = 1,
  pathLength = 542,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 317 316"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        opacity={opacity}
        stroke={stroke}
        strokeWidth={1}
        strokeDasharray="2 3"
        d="M83.9993,151C118.499,197 111.139,225.684 104.042,274.385C97.752,317.549 94.0717,339.889 209.499,232.499C270.475,175.77 250.577,80.1609 228.999,0.999592"
      />
      <path
        opacity={opacity}
        stroke={mask}
        strokeWidth={2}
        ref={forwardRef.line}
        strokeDashoffset={0}
        strokeDasharray={pathLength}
        d="M83.9993,151C118.499,197 111.139,225.684 104.042,274.385C97.752,317.549 94.0717,339.889 209.499,232.499C270.475,175.77 250.577,80.1609 228.999,0.999592"
      />
      <path
        opacity={0}
        ref={forwardRef.arrow}
        d="M81.3756 148.229C81.3373 148.002 81.5598 147.818 81.7762 147.899L87.7273 150.116C87.9437 150.197 87.9917 150.482 87.8136 150.629L82.9175 154.674C82.7395 154.821 82.469 154.72 82.4306 154.492L81.3756 148.229Z"
        fill={stroke}
      />
    </svg>
  )
}

export default ExpeditionRoute2
